import { useContext } from "react";
import { DispatchContext } from "bodycodi/cmap/app/components/common/context";
import { getTotalFoodDetail } from "bodycodi/cmap/app/js/common";
import icon_right_arrow_gray from "bodycodi/cmap/app/svg/icon_right_arrow_gray.svg";

function FoodDetail({ foodLensInfo }: any) {
  const { dispatch } = useContext(DispatchContext);

  const handleClickDtl = (i: number) => {
    const totalDetailInfo = getTotalFoodDetail([
      {
        nutrition: foodLensInfo.foodLensPartInfos[i].nutrionInfo,
        eatAmount: foodLensInfo.foodLensPartInfos[i].eatAmount,
      },
    ]);
    dispatch({
      type: "UPDATE",
      data: {
        comunityFoodDetail: {
          foodName: foodLensInfo.foodLensPartInfos[i]?.foodName,
          eatAmount: foodLensInfo.foodLensPartInfos[i]?.eatAmount,
          unit: foodLensInfo.foodLensPartInfos[i]?.nutrionInfo?.unit,
          nutrition: totalDetailInfo,
        },
      },
    });
    dispatch({
      type: "POP_UP_OPEN",
      id: "COMUNITY_FOOD_DTL_POP",
      open: { comunityFoodDtlPop: true },
    });
  };

  return (
    <div className="comunity-content-food-list">
      {foodLensInfo.foodLensPartInfos?.map((v: any, i: number) => {
        return (
          <div key={i} className="food-list-info" onClick={() => handleClickDtl(i)}>
            <div>
              <p className="name">{v.foodName}</p>
              <p className="unit">
                {v.nutrionInfo.unit}
                {v.eatAmount > 1 &&
                  ` x${v.eatAmount % 1 === 0 ? v.eatAmount : v.eatAmount.toFixed(1)}`}
              </p>
            </div>
            <div className="kcal-box">
              <p className="kcal">
                {Math.round(v.nutrionInfo.calories * v.eatAmount)}
                <span>kcal</span>
              </p>
              <img src={icon_right_arrow_gray} alt="right_arrow" />
            </div>
          </div>
        );
      })}
    </div>
  );
}

export default FoodDetail;
